import { isCssColor } from 'vuetify/lib/util/colorUtils'

export function getBackgroundColorData (color) {
  const data = {
    colorClasses: null,
    colorStyles: null
  }

  if (isCssColor(color)) {
    data.colorStyles = {
      'background-color': `${color}`,
      'border-color': `${color}`
    }
  } else if (color) {
    data.colorClasses = [color]
  }

  return data
}

export function getTextColorData (color) {
  const data = {
    colorClasses: [],
    colorStyles: {}
  }

  if (isCssColor(color)) {
    data.colorStyles = {
      color: `${color}`,
      'caret-color': `${color}`
    }
  } else if (color) {
    const [colorName, colorModifier] = color.toString().trim().split(' ', 2)
    data.colorClasses = [colorName + '--text']
    if (colorModifier) {
      data.colorClasses.push('text--' + colorModifier)
    }
  }

  return data
}
